/**
 * Global utility functions & polyfills
 */

//Cached version of jQuery getScript()
jQuery.cachedScript = function(url, async, options) {

  // Allow user to set any option except for dataType, cache, and url
  options = $.extend( options || {}, {
    cache: true,
    url: url,
    async: typeof async !== "undefined" ? async : true
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return jQuery.ajax( options );
};

//Responsive Breakpoints
var isTablet, isMobile900, isMobile;

if ($(document).width() <= 1024) {
    if ($(document).width() <= 900 && $(document).width() > 768) {
        isMobile900 = true;
    } else {
        isMobile900 = false;
    }
    if ($(document).width() > 768) {
        isTablet = true;
    } else {
        isTablet = false;
    }
    if ($(document).width() < 768) {
        isMobile = true;
    } else {
        isMobile = false;
    }
}

if (window.innerWidth < 768) {
    isMobile = true;
} else {
    isMobile = false;
}

//Returns the elements not in common between two arrays
Array.prototype.diff = function(a) {
    return this.filter(function(i) {return a.indexOf(i) < 0;});
};


/**
 * jQuery getScript() wrapper to support multiple script loading.
 */
$.getMultiScripts = function(arr, async) {
    var _arr = $.map(arr, function(src) {
        return $.cachedScript(src, async);
    });

    _arr.push($.Deferred(function( deferred ){
        $( deferred.resolve );
    }));

    return $.when.apply($, _arr);
}

/**
 * Module loader.
 */
var loader = (function() {

	var libs = {
		external : {
            //bxslider: ACC.config.commonResourcePath + "/js/libs/jquery.bxslider.min.js",
            readmore: ACC.config.commonResourcePath + "/js/libs/readmore.min.js",
            validationengine : ACC.config.commonResourcePath + "/js/libs/jquery.validationEngine.js",
            ve_locale : ACC.config.commonResourcePath + "/js/languages/jquery.validationEngine-" + currentLanguage + ".js",
            dotdotdot : ACC.config.commonResourcePath + "/js/libs/jquery.dotdotdot.min.js",
            nlplugin: ACC.config.commonResourcePath + "/js/plugin-nl.min.js",
            icheck: ACC.config.commonResourcePath + "/js/libs/icheck.min.js",
            cookie: ACC.config.commonResourcePath + "/js/libs/jquery.cookie.js",
            canvaseffects: ACC.config.commonResourcePath + "/js/libs/canvasEffects.min.js",
            isotope : ACC.config.commonResourcePath + "/js/libs/isotope.pkgd.min.js",
           // matchheight: ACC.config.commonResourcePath + "/js/libs/jquery.matchHeight.min.js",
            momentLocales: ACC.config.commonResourcePath + "/js/libs/moment-with-locales.min.js",
            datatable: ACC.config.commonResourcePath + "/js/libs/datatables.min.js"
		},
		modules : {

            csscontactus: ACC.config.commonResourcePath + "/js/modules/contact/css-contactus.js",

            moodsearch: ACC.config.commonResourcePath + "/js/modules/misc/moodsearch.js",
            cookiehandler: ACC.config.commonResourcePath + "/js/modules/misc/cookiehandler.js",
            caman:  ACC.config.commonResourcePath + "/js/modules/misc/caman.js",

            reparabilityajaxsearch: ACC.config.commonResourcePath + "/js/modules/reparability/reparabilityajaxsearch.min" + GSEB.constants.staticResourcesVersionFile + ".js",

            plpAjax: ACC.config.commonResourcePath + "/js/modules/plp/plp.ajax.js",
            plpBannerInjector: ACC.config.commonResourcePath + "/js/modules/plp/plp.banner.injector.js",

            krupsFullpage: ACC.config.commonResourcePath + "/js/modules/fullpage/fullpage-krups.js",
            fullpageHome: ACC.config.commonResourcePath + "/js/modules/fullpage/home.js",

            catImagesloaded: ACC.config.commonResourcePath + "/js/libs/imagesloaded.pkgd.min.js",
            catHammer: ACC.config.commonResourcePath + "/js/libs/hammer.min.js",
            catImagesloaded: ACC.config.commonResourcePath + "/js/libs/sequence.min.js",
            catSequence: ACC.config.commonResourcePath + "/js/customSlider.js",
            catCarousel: ACC.config.commonResourcePath + "/js/libs/jquery.sky.carousel-1.0.2.min.js",

            recipeModernizr: ACC.config.commonResourcePath + "/js/modules/recipe/modernizr.custom.js",
            recipeMasonry: ACC.config.commonResourcePath + "/js/modules/recipe/masonry.pkgd.min.js",
            recipeImagesloaded: ACC.config.commonResourcePath + "/js/modules/recipe/imagesloaded.pkgd.min.js",
            recipeClassie: ACC.config.commonResourcePath + "/js/modules/recipe/classie.js",
            recipeGridScrollFx: ACC.config.commonResourcePath + "/js/modules/recipe/gridScrollFx.js",

            cultureAnime: ACC.config.commonResourcePath + "/js/modules/culture/anime.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            cultureScrollMonitor: ACC.config.commonResourcePath + "/js/modules/culture/scrollMonitor.js",
            cultureMain: ACC.config.commonResourcePath + "/js/modules/culture/main.js",

            datatableDesignedFor: ACC.config.commonResourcePath + "/js/modules/datatable/datatableDesignedFor.js",

            globalmessages: ACC.config.commonResourcePath + "/js/modules/utils/globalmessages.js"
		}
	};

	var loadedDeps = [];

    const MODULES = {
//        ".minishow ul" : {
//            executable: libs.modules.sliderminishow
//        },
//        ".js-carousel" : {
//            executable: libs.modules.sliderrotatingbanners
//        },
//        "#CarouselDetailProduct" : {
//            executable: libs.modules.sliderdetailproducts
//        },
//        ".quoi-de-neuf .list-item, .communaute ul, .content-community-mobile-slider, .top-recette .owl-carousel, #CarouselDetailProductBig .carousel-inner, .owl-carousel-type2" : {
//            executable: libs.modules.slidermobileslides
//        },
//        ".mini-banner-slider, .category-page .mini-banners .container .banners-right": {
//            executable: libs.modules.sliderminibanner
//        },
//        ".top-recette.with-carousel .owl-carousel": {
//            executable: libs.modules.slidertoprecette
//        },
//        ".slider-1" : {
//            executable: libs.modules.sliderone
//        },
//        ".slider-4" : {
//            executable: libs.modules.sliderfour
//        },
//        ".slider-5, #ifuSelector, #ifuLanguage" : {
//            executable: libs.modules.sliderfive
//        },
//        ".slider-6" : {
//            executable: libs.modules.slidersix
//        },
//        "#CarouselRecettesPreferees" : {
//            executable: libs.modules.sliderfavouriterecipes
//        },
//        ".features-slider, #product-benefits" : {
//            dependencies: [libs.external.readmore, libs.external.matchheight],
//            executable: libs.modules.sliderfeatures
//        },
//        ".our-applications" : {
//            executable: libs.modules.sliderourapplications
//        },
        ".gocompare, #ScrollabeTableCompare": {
            executable: libs.modules.productcomparator
        },
        "#CountryFormData, #captchaerror, #AjaxContact, #ModalFeedback, #FormContact, [id^=Step], #FullFormContact, #FormContactActions, #ContactAddress, #RequestFormContact, #ContactFormCaptcha, profil-contact-select" :{
            dependencies: [libs.external.validationengine, libs.external.ve_locale],
            executable: libs.modules.csscontactus
        },
        "#ModalMessage, #ModalPassword, #ModalExplodedViews, .nostock, [class^='validate'], [data-analytics-contactFormSubmit], #FormStockAlert, #updatePasswordForm, #FormUserIds, .validate" : {
            dependencies: [libs.external.validationengine, libs.external.ve_locale]
        },
        "#nl-form, .nl-reset, .iCheck": {
            dependencies: [libs.external.nlplugin, libs.external.icheck],
            executable: libs.modules.moodsearch
        },
        ".cookie, .oldBrowsers": {
            dependencies: [libs.external.cookie],
            executable: libs.modules.cookiehandler
        },
        "#search_form_reparability, .search-area-reparability .search form #search-filter_reparability": {
            dependencies: [libs.external.readmore],
            executable: libs.modules.reparabilityajaxsearch
        },
        ".social-media-navtop" : {
            dependencies: [libs.external.canvaseffects],
            executable: libs.modules.caman
        },
        "#plp-facets-section, #plp-results-section, #plp-pagination-section, .product-list" : {
            async: false,
            executable: libs.modules.plpAjax,
            dependencies: [libs.modules.plpBannerInjector, libs.modules.productcomparator]
        },
	    ".krups-animate,.page-recipe-list,.page-cultureKrupsPage": {
	        executable: libs.modules.krupsFullpage
	    },
	    ".page-homepage" : {
		    executable: libs.modules.fullpageHome,
		    dependencies: [libs.external.momentLocales]
	    },
	    ".pageType-CategoryPage" : {
	    	dependencies: [libs.modules.catImagesloaded,
	    	               libs.modules.catHammer,
	    	               libs.modules.catImagesloaded,
	    	               libs.modules.catSequence,
	    	               libs.modules.catCarousel]
	    },
	    ".page-recipe-list,.page-cultureKrupsPage" : {
        async: false,
        executable: libs.modules.recipeGridScrollFx,
	    	dependencies: [libs.modules.recipeModernizr,
	    	               libs.modules.recipeMasonry,
	    	               libs.modules.recipeImagesloaded,
	    	               libs.modules.recipeClassie]
	    },
	    ".template-pages-layout-cultureDetailsPage" : {
	    	dependencies: [libs.modules.cultureAnime,libs.modules.cultureScrollMonitor,libs.modules.cultureMain]
	    },
	    ".cart-steps": {
	    	executable: libs.modules.globalmessages
	    },
      ".desc": {
          dependencies: [libs.external.readmore]
      },
      ".special-offers-v2-filters" : {
        async: false,
        executable:  libs.modules.specialoffers,
        dependencies: [libs.external.isotope]
      },
      "#designedfor-section" :{
        async: false,
        executable: libs.modules.datatableDesignedFor,
        dependencies: [libs.external.datatable]
    },
    };

    var loadDeps = function () {
        $.each(MODULES, function(selector, module) {
        	if($(selector).length){

        		var asyncLoad = typeof module.async !== "undefined" ? module.async : true;

        		if(typeof module.dependencies !== "undefined"){
        			if(typeof module.executable !== "undefined"){
        				$.getMultiScripts(module.dependencies.diff(loadedDeps), asyncLoad).done($.cachedScript(module.executable, asyncLoad));
        			} else {
        				$.getMultiScripts(module.dependencies.diff(loadedDeps), asyncLoad);
        			}
        			loadedDeps = loadedDeps.concat(module.dependencies.diff(loadedDeps));
        		} else if(typeof module.executable !== "undefined") {
        			$.cachedScript(module.executable, asyncLoad);
        		}

        	}
        });
    };

    return {
    	loadDeps: loadDeps
    };

}());

loader.loadDeps();

